import PropTypes from 'prop-types';
import replacement from '../../../services/Replacement';
import { PraiseBadgeIcon } from '../../PopupAlert/icons';
import EntityPreview from '../EntityPreview';
import { convertRichText } from '../MessageAlert';
import PopupAlertContent from '../PopupAlertContent';

export default function PraiseAlert({ praise }) {
    const title = `${replacement('praise.header')} Created`;
    const href = `/app/praise/${praise.id}`;

    const body = praise.message && convertRichText(praise.message);
    return (
        <PopupAlertContent title={title} href={href} icon={<PraiseBadgeIcon praise={praise} />}>
            <EntityPreview title={praise.title || body} subtitle={praise.title ? body : ''} />
        </PopupAlertContent>
    );
}

PraiseAlert.propTypes = {
    praise: PropTypes.shape({
        title: PropTypes.string,
        message: PropTypes.string,
    }).isRequired,
};
